














import { DropdownInputOptions, MultiValue } from '@/components/ui/DynamicTechTaskCard/types/input-field'
import AsyncValueMixin from '@/dynamic-tech-task/components/input/mixins/async-values'
import { Component } from 'vue-property-decorator'


@Component({
    name: 'MultiDropdownInputField'
})
export default class MultiDropdownInputField extends AsyncValueMixin<DropdownInputOptions, MultiValue> {}
